import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickToToggleContextualSidebar } from '../constants/events';
import { jsx as _jsx } from "react/jsx-runtime";
const RightSidebarToggle = ({
  toggleSidebar
}) => {
  const toggleRightSidebar = () => {
    toggleSidebar();
    trackEvent(getClickToToggleContextualSidebar());
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.buttons.ContextualSidebarToggle.tooltip"
    }),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(UIIconButton, {
      size: "small",
      onClick: toggleRightSidebar,
      "data-test-id": "contact-sidebar-toggle",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        size: 18
      })
    })
  });
};
RightSidebarToggle.displayName = 'RightSidebarToggle';
export default RightSidebarToggle;